import React from 'react';
import { ProtectedLayout } from '../components/layout/ProtectedLayout';

const MessagesPage: React.FC = () => (
  <ProtectedLayout>
    {() => (
      <div className="space-y-8">
        <header className="rounded-xl border border-border bg-card p-6 shadow-sm">
          <h1 className="text-3xl font-semibold text-foreground">Messages</h1>
          <p className="mt-2 text-sm text-muted-foreground">Messaging features will appear here soon.</p>
        </header>
      </div>
    )}
  </ProtectedLayout>
);

export default MessagesPage;
